import React from "react"
import stunned from '../../img/icon/stunned.png';

export default function Stunned() {
   return (
      <img src={stunned} alt="" />
   )
}
